<template>
	<page :class="{'z-full': isFull}">
		<module>
			<module-col size="320">
				<div class="side flex-column">
					<div class="tabs flex-center">
						<a class="flex-center" :class="{'z-crt': mode == 'scan'}" @click="mode = 'scan'"><i class="tf">&#xe62c;</i>扫码识别</a>
						<a class="flex-center" :class="{'z-crt': mode == 'input'}" @click="mode = 'input'"><i class="tf-search"></i>输入选择</a>
					</div>

					<div v-if="mode == 'scan'" class="side-scan-row flex-center">
						<div class="side-scan flex-center flex-grow" :class="scanState ? `z-${scanState}` : ''">
							<i v-if="scanState == 'loading'" class="tf-reload tf-spin"></i>
							<i v-else-if="scanState == 'success'" class="tf-check"></i>
							<i v-else-if="scanState == 'error'" class="tf-cross"></i>
							<i v-else class="tf">&#xe62c;</i>
							<span class="ellipsis">{{scanTip || '等待扫码输入中'}}</span>
						</div>
						<a class="side-camera flex-center" title="摄像头扫码" @click="cameraOpen"><i class="tf">&#xe6ba;</i></a>
					</div>
					<div v-else class="side-input flex-center">
						<c-select v-model="inputType" class="side-type" :options="inputTypeOptions" :clear="false" @change="changeInputType"></c-select>
						<c-select :key="inputType" v-model="rootId" class="flex-grow" async @search="searchRoot" @change="changeRoot" :placeholder="inputType == 'work' ? '请输入工单编号搜索' : '请输入产品编号搜索'">
							<template #option="{data, selected}">
								<select-option
									:name="data.name"
									:info="inputType == 'work' ? [`${data.data.product_code} | ${data.data.product_name} | ${data.data.product_spec}`] : []"
									:selected="selected"
								></select-option>
							</template>
						</c-select>
					</div>

					<dl v-if="root" class="side-info">
						<div v-for="(row, i) in infoRows" :key="i">
							<dt>{{row.label}}</dt>
							<dd>{{row.value}}</dd>
						</div>
					</dl>
					<c-empty v-else class="flex-grow" :message="mode == 'scan' ? '扫码自动搜索图纸' : '搜索编号选择查看'"></c-empty>
				</div>
			</module-col>

			<module-col enable-flex>
				<div class="bar flex-center">
					<c-select v-model="fieldKey" class="bar-field" :options="fieldOptions" :clear="false" placeholder="请选择预览字段" style="height: 32px;"></c-select>

					<ul v-if="currentFiles.length" class="bar-files flex-center">
						<li v-for="(file, i) in currentFiles" :key="i" class="flex-center" :class="{'z-crt': i == fileIndex}" :title="parseFile(file).name" @click="fileIndex = i">
							<img v-if="parseFile(file).media == 'image' && thumbFiles[i]" :src="thumbFiles[i]">
							<i v-else class="tf-file" :class="`tf-file-${parseFile(file).suffix}`"></i>
						</li>
					</ul>

					<div class="flex-grow"></div>
					<c-button :prepend-icon="isFull ? 'c-icon-dialog-normal' : 'c-icon-dialog-max'" @click="fullHandle">{{isFull ? '退出全屏' : '全屏'}}</c-button>
					<c-button v-if="currentFile && !isFull" prepend-icon="tf-download" @click="download({url: currentFile})">下载</c-button>
					<c-button prepend-icon="tf-clear" @click="clearHandle">清空</c-button>
				</div>

				<div class="main flex-grow">
					<div v-if="needTaskSelect" class="tasks-float flex-column">
						<div class="head flex-center">
							<i class="tf-order-plan"></i>
							<span>工序</span>
							<span class="count">{{taskOptions.length}}</span>
						</div>
						<ul>
							<li v-for="task in taskOptions" :key="task.value" class="flex-center" :class="{'z-crt': task.value == taskId}" @click="taskId = task.value">
								<span class="ellipsis flex-grow">{{task.name}}</span>
								<i v-if="task.value == taskId" class="tf-check"></i>
							</li>
						</ul>
					</div>

					<template v-if="currentFile">
						<div v-if="currentKind == 'image'" ref="viewer" class="viewer flex-center" :class="{'z-drag': scale > 1, 'z-dragging': dragging}" @wheel.prevent="wheelHandle" @mousedown.prevent="dragStart" @touchstart.prevent="touchStart" @touchmove.prevent="touchMove" @touchend="touchEnd" @touchcancel="touchEnd">
							<img v-if="signedFile" ref="viewImg" :src="signedFile" :style="{transform: `translate(${moveX}px, ${moveY}px) scale(${scale}) rotate(${rotate}deg)`}" @dragstart.prevent>
						</div>
						<div v-else-if="currentKind == 'video'" class="viewer flex-center">
							<video v-if="signedFile" :src="signedFile" controls autoplay></video>
						</div>
						<div v-else-if="currentKind == 'doc'" ref="officeBox" class="office"></div>
						<div v-else class="other flex-column flex-center">
							<i class="tf-file" :class="`tf-file-${parseFile(currentFile).suffix}`"></i>
							<p>{{parseFile(currentFile).name}}.{{parseFile(currentFile).suffix}}</p>
							<p class="tip">该格式暂不支持在线预览，请下载后查看</p>
							<c-link v-if="!isFull" @click="download({url: currentFile})">下载文件</c-link>
						</div>

						<a v-show="currentFiles.length > 1" class="arrow prev flex-center" @click="prevHandle"><i class="tf-angle-left"></i></a>
						<a v-show="currentFiles.length > 1" class="arrow next flex-center" @click="nextHandle"><i class="tf-angle-right"></i></a>

						<div v-if="currentKind == 'image'" class="zoom flex-center">
							<a class="zoom-btn flex-center" title="缩小" @click="scale = Math.max(0.1, parseFloat((scale - 0.1).toFixed(2)))"><i class="c-icon-minus"></i></a>
							<span class="zoom-percent">{{Math.round(scale * 100)}}%</span>
							<a class="zoom-btn flex-center" title="放大" @click="scale = Math.min(5, parseFloat((scale + 0.1).toFixed(2)))"><i class="c-icon-plus"></i></a>
							<i class="zoom-split"></i>
							<a class="text flex-center" @click="rotate = (rotate + 90) % 360"><i class="c-icon-rotate-right"></i>旋转</a>
							<a class="text flex-center" @click="resetView"><i class="c-icon-refresh"></i>重置</a>
						</div>
					</template>

					<c-empty v-else-if="root" message="当前字段暂无图片或附件数据"></c-empty>

					<div v-else class="steps flex-center">
						<div class="steps-icon flex-center">
							<i class="tf">&#xe776;</i>
						</div>
						<p class="steps-title">扫码查看图纸</p>
						<ul class="flex-center">
							<li>
								<i class="num done tf-check"></i>
								<p class="title">激活扫码</p>
								<p class="describe">页面已就绪，可直接使用扫码枪</p>
							</li>
							<li>
								<i class="num">2</i>
								<p class="title">扫描二维码</p>
								<p class="describe">自动识别并查询关联数据</p>
							</li>
							<li>
								<i class="num">3</i>
								<p class="title">查看图纸</p>
								<p class="describe">切换工序与字段查看附件、图片</p>
							</li>
						</ul>
					</div>
				</div>
			</module-col>
		</module>

		<!--摄像头扫码浮层：getUserMedia+jsQR循环解码（同H5 camera_scan方案，浏览器与APK WebView通用）-->
		<div v-if="cameraOn" class="camera flex-column flex-center">
			<div class="camera-main">
				<video ref="cameraVideo" autoplay playsinline muted></video>
				<canvas ref="cameraCanvas" class="camera-canvas"></canvas>
				<div class="camera-line"></div>
			</div>
			<p class="camera-tip">将二维码对准框内，识别后自动关闭</p>
			<div class="camera-close flex-center" @click="cameraClose"><i class="c-icon-cross"></i></div>
		</div>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import jsQR from 'jsqr'
	import dictList from '@/store/dict.js'

	//扫码监听注册后无法注销（App.vue registerScanEvent 仅追加），
	//全局仅注册一次，回调转发给当前存活页面实例，避免多次进出页面后重复触发
	let scanViewInited = false;
	let scanViewVm = null;

	function registerScanView(app) {
		if (scanViewInited) return;
		scanViewInited = true;
		//扫码状态：识别中（不回显扫码原文）
		app.scanCode({
			parse: false,
			success: () => {
				if (scanViewVm && !scanViewVm._destroyed) scanViewVm.scanState = 'loading';
			}
		});
		//扫码内容解析（二维码内容已包含业务ID）
		app.scanCode({
			parse: true,
			success: data => {
				if (scanViewVm && !scanViewVm._destroyed) scanViewVm.scanResolve(data);
			}
		});
	}

	export default {
		name: 'm_scan_view',

		data() {
			return {
				mode: 'scan',
				//扫码动态状态：空=等待扫码 loading=识别中 success=识别完成 error=识别失败
				scanState: '',
				//摄像头扫码浮层开关
				cameraOn: false,
				inputType: 'work',
				inputTypeOptions: [{
					name: '工单',
					value: 'work'
				}, {
					name: '产品',
					value: 'product'
				}],
				//输入选择模式：已选中的业务数据ID
				rootId: '',

				//当前查询根业务：{type: work|task|product, id}
				root: null,
				//工单串联数据：{info: 工单详情, tasks: [{id, process_name}]}
				workData: null,
				//产品详情数据
				productData: null,
				//任务详情数据（任务入口）
				taskData: null,
				//工单下任务自定义字段值缓存：{task_id: customFieldValues}
				taskValuesCache: {},
				//当前选中任务的自定义字段值
				taskValuesCurrent: null,

				fieldKey: '',
				//预览字段是否手动选择过（手动选择后扫码保持所选字段，不重新自动选择）
				fieldManual: false,
				//上次选中的工序名称：扫新工单时同名工序优先继承
				lastTaskName: '',
				taskId: '',
				fileIndex: 0,
				//当前字段各文件的缩略图预签名地址
				thumbFiles: [],
				//当前预览文件的预签名地址
				signedFile: '',

				scale: 1,
				rotate: 0,
				//图片放大后的拖拽平移偏移
				moveX: 0,
				moveY: 0,
				dragging: false,
				//全屏预览状态
				isFull: false,

				docType: [
					'doc', 'dot', 'wps', 'wpt', 'docx', 'dotx', 'docm', 'dotm', 'rtf',
					'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps',
					'xls', 'xlt', 'et', 'xlsx', 'xltx', 'csv', 'xlsm', 'xltm',
					'pdf'
				]
			}
		},

		computed: {
			...mapState(['customField']),

			//扫码框仅展示动态状态，不回显扫码原文
			scanTip() {
				return {
					loading: '扫描识别中...',
					success: '扫描成功，可继续扫码',
					error: '识别失败，请重新扫码'
				}[this.scanState] || '';
			},

			//业务元数据：value=串联标识 workType=自定义字段配置业务类型（任务与工序共用配置，取9）
			bizMeta() {
				return [{
					biz: 'work',
					label: '工单',
					workType: 3
				}, {
					biz: 'product',
					label: '产品',
					workType: 7
				}, {
					biz: 'task',
					label: '任务',
					workType: 9
				}];
			},

			//可选预览字段：当前业务串联范围内所有图片、附件类型自定义字段
			//未查询单据前按当前业务类型（输入类型）展示可配置字段并默认选中第一个；
			//无业务数据时仅不显示工序任务选择（needTaskSelect要求工单已加载），任务字段仍可选
			fieldOptions() {
				let type = this.root ? this.root.type : this.inputType;
				let bizs = type == 'product' ? ['product'] : ['work', 'product', 'task'];
				let options = [];
				bizs.forEach(biz => {
					let meta = this.bizMeta.find(item => item.biz == biz);
					(this.customField[meta.workType] || []).forEach(field => {
						if (!['image', 'file'].includes(field.config_json.type)) return;
						options.push({
							value: `${biz}:${field.field_code}`,
							name: `${meta.label} - ${field.field_title}`,
							biz: biz,
							field_code: field.field_code
						});
					});
				});
				return options;
			},

			currentOption() {
				return this.fieldOptions.find(item => item.value == this.fieldKey) || null;
			},

			//任务预览字段按任务工序区分，仅选中任务字段时才需再选择工序任务（工单、任务入口均串联了工单任务列表）
			needTaskSelect() {
				return !!this.currentOption && this.currentOption.biz == 'task' && !!this.workData && this.workData.tasks.length > 0;
			},

			taskOptions() {
				let tasks = this.workData ? this.workData.tasks : [];
				let totals = {};
				tasks.forEach((item, i) => {
					let name = item.process_name || `任务${i + 1}`;
					totals[name] = (totals[name] || 0) + 1;
				});
				let counts = {};
				return tasks.map((item, i) => {
					let name = item.process_name || `任务${i + 1}`;
					counts[name] = (counts[name] || 0) + 1;
					//同工序多任务时追加序号区分
					return {
						value: item.id,
						name: totals[name] > 1 ? `${name}（${counts[name]}）` : name
					};
				});
			},

			currentFiles() {
				if (!this.currentOption) return [];
				return this.filesOf(this.currentOption.field_code, this.valuesOf(this.currentOption.biz));
			},

			currentFile() {
				return this.currentFiles[this.fileIndex] || '';
			},

			//文件列表标识：仅在列表内容真正变化时重新签名缩略图
			currentFilesKey() {
				return this.currentFiles.join(',');
			},

			currentKind() {
				if (!this.currentFile) return '';
				let info = this.parseFile(this.currentFile);
				if (info.media == 'image') return 'image';
				if (info.media == 'video') return 'video';
				if (this.docType.includes(info.suffix.toLocaleLowerCase())) return 'doc';
				return 'other';
			},

			//左侧业务基本信息
			infoRows() {
				if (!this.root) return [];
				let dictName = (dict, value) => {
					let item = (dictList[dict] || []).find(item => item.value == value);
					return item ? item.name : (value || '-');
				};
				if (this.root.type == 'work' && this.workData) {
					let data = this.workData.info || {};
					return [{
						label: '工单编号',
						value: data.work_code || '-'
					}, {
						label: '产品编号',
						value: data.product_code || '-'
					}, {
						label: '产品名称',
						value: data.product_name || '-'
					}, {
						label: '产品规格',
						value: data.product_spec || '-'
					}, {
						label: '计划数',
						value: data.plan_count || '-'
					}, {
						label: '计划开始时间',
						value: data.plan_start_date || '-'
					}, {
						label: '计划结束时间',
						value: data.plan_end_date || '-'
					}, {
						label: '备注',
						value: data.remark || '-'
					}].concat(this.customRows(data));
				}
				if (this.root.type == 'task' && this.taskData) {
					let data = this.taskData;
					return [{
						label: '工单编号',
						value: data.work_code || '-'
					}, {
						label: '工序名称',
						value: data.process_name || '-'
					}, {
						label: '加工类型',
						value: dictName('processTypeDic', data.process_type)
					}, {
						label: '产品编号',
						value: data.product_code || '-'
					}, {
						label: '产品名称',
						value: data.product_name || '-'
					}, {
						label: '计划数',
						value: data.plan_count || '-'
					},{
						label: '计划开始时间',
						value: data.plan_start_date || '-'
					}, {
						label: '计划结束时间',
						value: data.plan_end_date || '-'
					}, {
						label: '工单备注',
						value: data.work_remark || '-'
					}, {
						label: '备注',
						value: data.remark || '-'
					}].concat(this.customRows(data));
				}
				if (this.root.type == 'product' && this.productData) {
					let data = this.productData;
					return [{
						label: '产品编号',
						value: data.product_code || '-'
					}, {
						label: '产品名称',
						value: data.product_name || '-'
					}, {
						label: '产品规格',
						value: data.product_spec || '-'
					}, {
						label: '单位',
						value: data.unit || '-'
					}].concat(this.customRows(data));
				}
				return [];
			}
		},

		watch: {
			//预览字段列表变化：当前选中项仍存在则保留，否则默认选中第一个（immediate覆盖配置先于页面加载的场景）
			fieldOptions: {
				immediate: true,
				handler(options) {
					if (!options.find(item => item.value == this.fieldKey)) {
						this.setFieldKey(options[0] ? options[0].value : '');
						//所选字段已不在可选范围（如切换到产品口径），手动选择标记失效
						this.fieldManual = false;
					}
				}
			},

			fieldKey(val) {
				//非程序性赋值（setFieldKey）即为手动选择：扫码后保持所选字段
				if (val != this._autoField) {
					this.fieldManual = true;
				}
				if (this.needTaskSelect && !this.taskId) {
					this.taskId = this.defaultTaskId();
				}
				if (!this.needTaskSelect) {
					this.taskValuesCurrent = null;
				} else {
					this.updateTaskValues();
				}
				this.fileIndex = 0;
			},

			taskId(val) {
				//记录当前选中的工序名称：扫新工单时继承同名工序
				let task = (this.workData ? this.workData.tasks : []).find(item => item.id == val);
				if (task) this.lastTaskName = task.process_name;
				this.updateTaskValues();
				this.fileIndex = 0;
			},

			'currentFiles.length'(length) {
				if (this.fileIndex >= length) {
					this.fileIndex = 0;
				}
			},

			//文件列表变化：批量获取缩略图预签名地址
			currentFilesKey(key) {
				this.thumbFiles = [];
				this.signThumbs(key ? key.split(',') : []);
			},

			//当前文件变化：获取预签名地址后再渲染（OSS私有读，直连原始地址会403）
			currentFile(file) {
				this.scale = 1;
				this.rotate = 0;
				this.moveX = 0;
				this.moveY = 0;
				this.dragEnd();
				this.signedFile = '';
				this.clearOffice();
				if (file) {
					this.signCurrent(file);
				}
			},

			//缩放/旋转/容器尺寸变化后溢出量随之变化：收回超界平移，未溢出方向回到居中
			scale() {
				this.limitMove();
			},

			rotate() {
				this.limitMove();
			},

			//全屏切换改变容器尺寸，DOM更新后重算平移边界
			isFull() {
				this.$nextTick(() => this.limitMove());
			}
		},

		mounted() {
			//附件签名请求序号，用于丢弃过期响应
			this._thumbSeq = 0;
			this._signSeq = 0;
			//最近一次程序性赋值的预览字段，供fieldKey watch识别手动选择
			this._autoField = '';

			this.$store.dispatch('updateFieldConfig');

			//Esc退出：优先关摄像头扫码浮层，其次退出全屏（对齐浏览器全屏习惯）
			this._escHandle = e => {
				if (e.key != 'Escape') return;
				if (this.cameraOn) {
					this.cameraClose();
				} else if (this.isFull) {
					this.isFull = false;
				}
			};
			document.addEventListener('keydown', this._escHandle);

			//全屏状态同步（含Esc等浏览器方式退出）
			this._fullChange = () => {
				if (document.documentElement.requestFullscreen) this.isFull = !!document.fullscreenElement;
			};
			document.addEventListener('fullscreenchange', this._fullChange);

			//注册全局扫码监听（仅首次），并指向当前实例
			registerScanView(this);
			scanViewVm = this;
		},

		beforeDestroy() {
			this._destroyed = true;
			if (scanViewVm == this) {
				scanViewVm = null;
			}
			document.removeEventListener('keydown', this._escHandle);
			document.removeEventListener('fullscreenchange', this._fullChange);
			//页面销毁时关闭摄像头，释放设备占用
			this.cameraClose();
			//页面销毁时若仍处于全屏则退出，避免全屏残留
			if (document.fullscreenElement) {
				document.exitFullscreen();
			}
			this.dragEnd();
			this.clearOffice();
		},

		methods: {
			/*******自定义字段行：按配置顺序渲染，排除图片/附件（file）类型字段*******/
			customRows(data) {
				let customs = (data || {}).customFieldValues || {};
				return Object.keys(customs).map(key => customs[key] || {}).filter(field => {
					//排除图片/附件类型自定义字段（image=图片、file=附件，两种独立类型）
					return !['file', 'image'].includes((field.config_json || {}).type);
				}).map(field => {
					let config = field.config_json || {};
					let value = field.value;
					if (config.type == 'rel_object') {
						//关联对象字段优先取后端拼装的显示值
						value = field.display_value || value;
					} else if (config.type == 'option' && (config.options || []).length) {
						let item = config.options.find(item => item.value == value);
						value = item ? item.name : value;
					}
					if (Array.isArray(value)) value = value.join('、');
					return {
						label: field.field_title || field.field_code,
						value: (value === 0 ? '0' : value) || '-'
					};
				});
			},

			/*******扫码识别：二维码内容已包含业务ID，直接串联查询*******/
			scanResolve(scanData) {
				//查询完成后回写扫码状态（成功/失败）
				let done = ok => {
					this.scanState = ok ? 'success' : 'error';
				};
				if (scanData.in_work_id) {
					this.loadWorkRoot(scanData.in_work_id, done);
				} else if (scanData.in_task_id) {
					this.loadTaskRoot(scanData.in_task_id, done);
				} else if (scanData.in_product_id) {
					this.loadProductRoot(scanData.in_product_id, done);
				} else {
					this.scanState = 'error';
					this.$message({
						message: '二维码内容无法识别'
					});
				}
			},

			/*******摄像头扫码：getUserMedia+jsQR循环解码（同H5方案，浏览器与APK WebView通用）*******/
			cameraOpen() {
				if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
					this.$message({
						message: '当前环境不支持摄像头调用'
					});
					return;
				}
				navigator.mediaDevices.getUserMedia({
					video: {facingMode: 'environment'}
				}).then(stream => {
					this._cameraStream = stream;
					this.cameraOn = true;
					this.$nextTick(() => {
						this.$refs.cameraVideo.srcObject = stream;
						this.cameraScan();
					});
				}).catch(err => {
					this.$message({
						message: err.name == 'NotAllowedError' ? '暂无摄像头权限' : '摄像头调用失败'
					});
				});
			},

			cameraScan() {
				let canvas = this.$refs.cameraCanvas;
				let video = this.$refs.cameraVideo;
				let ctx = canvas.getContext('2d');
				!function loop() {
					this._cameraTimer = setTimeout(() => {
						if (!this.cameraOn) return;
						//视频流未就绪时跳过本帧
						if (!video.videoWidth) {
							loop.call(this);
							return;
						}
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
						let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
						let code = jsQR(imageData.data, imageData.width, imageData.height);
						if (code) {
							this.cameraClose();
							this.cameraResolve(code.data);
						} else {
							loop.call(this);
						}
					}, 400);
				}.call(this);
			},

			//二维码原文解析（同main.js scanCode的parse逻辑）后走扫码处理链
			cameraResolve(text) {
				try {
					let search = /http(s)?:/.test(text) ? new URL(text).search : text;
					let data = {};
					new URLSearchParams(search).forEach((value, key) => {
						data[key] = value;
					});
					this.scanState = 'loading';
					this.scanResolve(data);
				} catch(e) {
					this.scanState = 'error';
					this.$message({
						message: '二维码内容解析失败'
					});
				}
			},

			cameraClose() {
				clearTimeout(this._cameraTimer);
				this._cameraStream && this._cameraStream.getTracks().forEach(track => track.stop());
				this._cameraStream = null;
				this.cameraOn = false;
			},

			/*******输入选择：远程搜索下拉（工单走/work/optionList，产品复用/system/options）*******/
			searchRoot(keyword, resolve) {
				if (this.inputType == 'work') {
					//工单下拉专用接口：返回工单+产品字段，映射为c-select选项结构
					this.request({
						url: '/work/optionList',
						data: {
							keyword
						},
						success: data => resolve(data.map(item => {
							return {
								name: item.work_code,
								value: item.id,
								data: item
							};
						}))
					});
				} else {
					this.request({
						url: '/system/options',
						data: {
							options_code: 'PRODUCT',
							keyword
						},
						success: data => resolve(data)
					});
				}
			},

			//切换业务类型：清空已选与已加载数据
			changeInputType() {
				this.rootId = '';
				this.resetData();
			},

			//下拉选中业务数据后加载串联信息（c-select的change首参为选项对象，需取其value作为业务ID）
			changeRoot(option) {
				let id = option && typeof option == 'object' ? option.value : option;
				if (!id) {
					this.resetData();
					return;
				}
				if (this.inputType == 'work') {
					this.loadWorkRoot(id);
				} else {
					this.loadProductRoot(id);
				}
			},

			/*******工单入口：串联工单、产品、任务*******/
			loadWorkRoot(id, done) {
				this.resetData();
				this.request({
					url: '/tool/scan_view/work_info',
					data: {
						id
					},
					loading: true,
					success: data => {
						this.workData = {
							info: data.detailInfo,
							tasks: (data.taskList || []).map(item => {
								return {
									id: item.id,
									process_name: item.process_name
								};
							})
						};
						this.root = {type: 'work', id};
						this.loadProductChain(data.detailInfo.product_id);
						done && done(true);
					},
					fail: () => {
						done && done(false);
					}
				});
			},

			/*******任务入口：串联其工单与产品*******/
			loadTaskRoot(id, done) {
				this.resetData();
				this.request({
					url: '/task/detail',
					data: {
						id
					},
					loading: true,
					success: data => {
						this.taskData = data;
						this.root = {type: 'task', id};
						if (data.work_id) {
							this.request({
								url: '/tool/scan_view/work_info',
								data: {
									id: data.work_id
								},
								success: wdata => {
									this.workData = {
										info: wdata.detailInfo,
										//任务入口同样串联工单任务列表，供工序任务下拉选择
										tasks: (wdata.taskList || []).map(item => {
											return {
												id: item.id,
												process_name: item.process_name
											};
										})
									};
									this.loadProductChain(wdata.detailInfo.product_id);
								}
							});
						} else {
							this.autoSelect();
						}
						done && done(true);
					},
					fail: () => {
						done && done(false);
					}
				});
			},

			/*******产品入口：仅产品自身字段*******/
			loadProductRoot(id, done) {
				this.resetData();
				this.request({
					url: '/product/detail',
					data: {
						id
					},
					loading: true,
					success: data => {
						this.productData = data;
						this.root = {type: 'product', id};
						this.autoSelect();
						done && done(true);
					},
					fail: () => {
						done && done(false);
					}
				});
			},

			//串联加载产品详情后自动选择预览字段
			loadProductChain(product_id) {
				if (product_id) {
					this.request({
						url: '/product/detail',
						data: {
							id: product_id
						},
						success: data => {
							this.productData = data;
							this.autoSelect();
						}
					});
				} else {
					this.autoSelect();
				}
			},

			/*******自动选择第一个有文件的预览字段（手动选择过的字段扫码后保持）*******/
			//程序性赋值预览字段：记录_autoField，供fieldKey watch区分手动选择
			setFieldKey(value) {
				this._autoField = value;
				this.fieldKey = value;
			},

			//默认工序任务：任务入口为所扫任务；工单入口按名称继承上次选中的工序，否则第一个
			defaultTaskId() {
				if (this.root.type == 'task') return this.root.id;
				let tasks = this.workData ? this.workData.tasks : [];
				let inherit = tasks.find(item => item.process_name == this.lastTaskName);
				return inherit ? inherit.id : (tasks[0] ? tasks[0].id : '');
			},

			autoSelect() {
				this.fileIndex = 0;

				let options = this.fieldOptions;
				let tasks = this.workData ? this.workData.tasks : [];
				//工序查找顺序：上次选中的同名工序置顶（继承优先），其余保持原序
				let scanTasks = tasks.slice();
				let ii = scanTasks.findIndex(item => item.process_name == this.lastTaskName);
				if (ii > 0) scanTasks.unshift(scanTasks.splice(ii, 1)[0]);
				//任务入口默认所扫任务；工单入口按名称继承上次选中的工序，否则第一个工序
				this.taskId = this.defaultTaskId();
				//手动选择的预览字段：扫码后保持所选（工序已按继承默认选中）
				if (this.fieldManual) {
					if (options.find(item => item.value == this.fieldKey)) return;
					this.fieldManual = false;
				}
				this.setFieldKey('');
				//任务入口：存在任务预览字段时优先选中第一个任务字段
				if (this.root.type == 'task') {
					let taskOption = options.find(item => item.biz == 'task');
					if (taskOption) {
						this.setFieldKey(taskOption.value);
						return;
					}
				}
				let oi = 0;
				let nextOption = () => {
					if (oi >= options.length) {
						//无可用数据时默认选中第一个字段
						this.setFieldKey(options[0] ? options[0].value : '');
						this.taskId = this.defaultTaskId();
						return;
					}
					let option = options[oi++];
					if (option.biz == 'task' && this.root.type == 'work') {
						//任务字段需逐个任务查找有数据的任务工序
						let ti = 0;
						let nextTask = () => {
							if (ti >= scanTasks.length) return nextOption();
							let task = scanTasks[ti++];
							this.getTaskValues(task.id, values => {
								if (this.filesOf(option.field_code, values).length) {
									this.setFieldKey(option.value);
									this.taskId = task.id;
								} else {
									nextTask();
								}
							});
						};
						nextTask();
					} else {
						if (this.filesOf(option.field_code, this.valuesOf(option.biz)).length) {
							this.setFieldKey(option.value);
						} else {
							nextOption();
						}
					}
				};
				nextOption();
			},

			//获取任务自定义字段值（带缓存）
			getTaskValues(taskId, callback) {
				if (this.root.type == 'task' && taskId == this.root.id) {
					return callback(this.taskData ? this.taskData.customFieldValues : null);
				}
				if (this.taskValuesCache[taskId]) {
					return callback(this.taskValuesCache[taskId]);
				}
				this.request({
					url: '/task/detail',
					data: {
						id: taskId
					},
					success: data => {
						this.$set(this.taskValuesCache, taskId, data.customFieldValues);
						callback(data.customFieldValues);
					}
				});
			},

			updateTaskValues() {
				if (this.needTaskSelect && this.taskId) {
					this.getTaskValues(this.taskId, values => {
						this.taskValuesCurrent = values;
					});
				} else {
					this.taskValuesCurrent = null;
				}
			},

			//各业务自定义字段值
			valuesOf(biz) {
				if (biz == 'work') return this.workData && this.workData.info ? this.workData.info.customFieldValues : null;
				if (biz == 'product') return this.productData ? this.productData.customFieldValues : null;
				//任务入口未串联工单（无工序下拉）时取所扫任务自身字段值
				if (this.root && this.root.type == 'task' && !this.needTaskSelect) return this.taskData ? this.taskData.customFieldValues : null;
				return this.taskValuesCurrent;
			},

			//字段文件列表归一化
			filesOf(field_code, values) {
				if (!values || !values[field_code]) return [];
				let value = values[field_code].value;
				if (!value) return [];
				return Array.isArray(value) ? value : String(value).split(',');
			},

			prevHandle() {
				this.fileIndex = this.fileIndex <= 0 ? this.currentFiles.length - 1 : this.fileIndex - 1;
			},

			nextHandle() {
				this.fileIndex = this.fileIndex >= this.currentFiles.length - 1 ? 0 : this.fileIndex + 1;
			},

			//图片预览滚轮缩放：上滚放大下滚缩小，步长与范围同缩放按钮（0.1~5）
			wheelHandle(e) {
				//防护：ctrl+wheel（系统捏合手势转换）、鼠标拖动中、触摸/按下后500ms内的滚轮一律忽略——
				//触屏驱动（含HID鼠标模拟模式）会把单指滑动转成wheel事件，防止单指拖动误触发缩放
				if (e.ctrlKey || this.dragging || Date.now() - (this._lastTouchTs || 0) < 500) return;
				let step = e.deltaY < 0 ? 0.1 : -0.1;
				this.scale = Math.min(5, Math.max(0.1, parseFloat((this.scale + step).toFixed(2))));
			},

			//计算当前缩放/旋转下图片相对容器的可平移边界：显示尺寸超出容器的方向才可平移，边界为该方向溢出量的一半
			moveRange() {
				let viewer = this.$refs.viewer;
				let img = this.$refs.viewImg;
				//图片未渲染或未加载完成（布局尺寸为0）时不可平移
				if (!viewer || !img || !img.offsetWidth) return null;
				//offsetWidth/offsetHeight为布局尺寸（不受transform影响），旋转90°奇数倍时显示宽高互换
				let swap = Math.round(this.rotate / 90) % 2 != 0;
				let width = (swap ? img.offsetHeight : img.offsetWidth) * this.scale;
				let height = (swap ? img.offsetWidth : img.offsetHeight) * this.scale;
				return {
					x: Math.max(0, (width - viewer.clientWidth) / 2),
					y: Math.max(0, (height - viewer.clientHeight) / 2)
				};
			},

			//按可平移边界限制平移量：未溢出的方向锁定居中；溢出方向平移不超过溢出量，
			//另加100px松弛量——图片边缘可拖至距容器边界100px处，而非只能刚好贴边
			limitMove() {
				let range = this.moveRange();
				if (!range) {
					this.moveX = 0;
					this.moveY = 0;
					return;
				}
				//边界松弛量：溢出方向边界放宽100px
				let slack = 100;
				let clamp = (val, bound) => bound ? Math.min(bound + slack, Math.max(-(bound + slack), val)) : 0;
				this.moveX = clamp(this.moveX, range.x);
				this.moveY = clamp(this.moveY, range.y);
			},

			//可平移判断：放大后至少一个方向超出容器才可拖拽（鼠标与触屏手势共用门槛）
			canPan() {
				let range = this.moveRange();
				return this.scale > 1 && !!range && (range.x > 0 || range.y > 0);
			},

			/*******图片放大后拖拽平移（仅左键且scale>1）*******/
			dragStart(e) {
				//记录按下时间戳（含HID鼠标模拟模式触摸屏）：其后500ms内的滚轮事件视为驱动模拟，忽略
				this._lastTouchTs = Date.now();
				if (e.button != 0 || !this.canPan()) return;
				this.dragging = true;
				this._dragStart = {
					x: e.clientX,
					y: e.clientY,
					mx: this.moveX,
					my: this.moveY
				};
				document.addEventListener('mousemove', this.dragMove);
				document.addEventListener('mouseup', this.dragEnd);
			},

			dragMove(e) {
				if (!this.dragging) return;
				this.moveX = this._dragStart.mx + e.clientX - this._dragStart.x;
				this.moveY = this._dragStart.my + e.clientY - this._dragStart.y;
				this.limitMove();
			},

			dragEnd() {
				if (!this.dragging) return;
				this.dragging = false;
				document.removeEventListener('mousemove', this.dragMove);
				document.removeEventListener('mouseup', this.dragEnd);
			},

			/*******触屏手势：单指拖动平移图片 + 双指捏合缩放*******/
			touchStart(e) {
				this._lastTouchTs = Date.now();
				if (e.touches.length >= 2) {
					//双指捏合缩放：记录两指间距与当前缩放基准
					let dx = e.touches[0].clientX - e.touches[1].clientX;
					let dy = e.touches[0].clientY - e.touches[1].clientY;
					this._pinchDist = Math.hypot(dx, dy);
					this._pinchScale = this.scale;
					this._pinchMid = {
						x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
						y: (e.touches[0].clientY + e.touches[1].clientY) / 2,
						mx: this.moveX,
						my: this.moveY
					};
					this._touchStart = null;
					this.dragging = false;
				} else if (e.touches.length == 1) {
					this._pinchDist = 0;
					//与鼠标拖拽同门槛：放大后至少一个方向超出容器才启动单指拖动
					if (this.canPan()) {
						this._touchStart = {x: e.touches[0].clientX, y: e.touches[0].clientY, mx: this.moveX, my: this.moveY};
						this.dragging = true;
					} else {
						this._touchStart = null;
					}
				}
			},
			
			touchMove(e) {
				this._lastTouchTs = Date.now();
				if (e.touches.length >= 2 && this._pinchDist) {
					//双指缩放：按间距比例缩放，范围0.1~5；同时以两指中心点平移
					let dx = e.touches[0].clientX - e.touches[1].clientX;
					let dy = e.touches[0].clientY - e.touches[1].clientY;
					let dist = Math.hypot(dx, dy);
					let ratio = dist / this._pinchDist;
					this.scale = Math.min(5, Math.max(0.1, parseFloat((this._pinchScale * ratio).toFixed(2))));
					if (this._pinchMid) {
						let midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
						let midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
						this.moveX = this._pinchMid.mx + midX - this._pinchMid.x;
						this.moveY = this._pinchMid.my + midY - this._pinchMid.y;
					}
					//缩放后溢出量变化，同步限制平移范围
					this.limitMove();
				} else if (e.touches.length == 1 && this._touchStart) {
					//单指拖动平移
					this.moveX = this._touchStart.mx + e.touches[0].clientX - this._touchStart.x;
					this.moveY = this._touchStart.my + e.touches[0].clientY - this._touchStart.y;
					this.limitMove();
				}
			},
			
			touchEnd(e) {
				this._lastTouchTs = Date.now();
				if (e.touches.length < 2) {
					//双指松开后重置捏合基准；若仍留一指则切换为单指拖动
					this._pinchDist = 0;
					this._pinchMid = null;
				}
				if (e.touches.length == 1) {
					//双指捏合后松开一指：可平移时才切换为单指拖动（门槛同启动）
					if (this.canPan()) {
						this._touchStart = {x: e.touches[0].clientX, y: e.touches[0].clientY, mx: this.moveX, my: this.moveY};
						this.dragging = true;
					} else {
						this._touchStart = null;
						this.dragging = false;
					}
				} else if (e.touches.length == 0) {
					this._touchStart = null;
					this.dragging = false;
				}
			},

			//重置缩放、旋转与平移
			resetView() {
				this.scale = 1;
				this.rotate = 0;
				this.moveX = 0;
				this.moveY = 0;
			},

			/*******全屏预览：documentElement浏览器全屏（F11效果；body下下拉面板仍在全屏子树内可正常显示），伪全屏遮罩盖住应用头/侧栏*******/
			fullHandle() {
				this.isFull = !this.isFull;
			},

			clearHandle() {
				this.resetData();
				this.scanState = '';
				this.rootId = '';
				//恢复初始态：预览字段回到默认第一个并恢复自动选择
				this.setFieldKey(this.fieldOptions[0] ? this.fieldOptions[0].value : '');
				this.fieldManual = false;
				this.lastTaskName = '';
			},

			resetData() {
				this.clearOffice();
				this.root = null;
				this.workData = null;
				this.productData = null;
				this.taskData = null;
				this.taskValuesCache = {};
				this.taskValuesCurrent = null;
				//fieldKey不在此清空：手动选择的预览字段需在扫码加载后保持
				this.taskId = '';
				this.fileIndex = 0;
				this.thumbFiles = [];
				this.signedFile = '';
				this.scale = 1;
				this.rotate = 0;
			},

			/*******附件鉴权（OSS私有读，访问前需获取预签名地址）*******/
			//urlType：0普通访问 3缩略图（服务端压缩360*360）
			signPaths(files, urlType, success, loading) {
				return this.request({
					url: '/oss/weboffice/getPreViewUrl',
					data: {
						file_paths: files,
						urlType
					},
					loading,
					success: data => success(data.urls || [])
				});
			},

			//批量获取当前字段文件的缩略图地址（静默加载，避免切换字段时闪烁）
			signThumbs(files) {
				if (!files.length) return;
				let seq = ++this._thumbSeq;
				this.signPaths(files, 3, urls => {
					if (this._destroyed || seq != this._thumbSeq) return;
					this.thumbFiles = urls;
				});
			},

			//获取当前预览文件地址：图片/视频直接渲染，文档转交WebOffice
			signCurrent(file) {
				let seq = ++this._signSeq;
				this.signPaths([file], 0, urls => {
					if (this._destroyed || seq != this._signSeq || this.currentFile != file) return;
					let signed = urls[0];
					if (!signed) return;
					if (this.currentKind == 'doc') {
						this.$nextTick(() => {
							this.initOffice(file, signed);
						});
					} else {
						this.signedFile = signed;
					}
				}, true);
			},

			/*******WebOffice文档预览*******/
			initOffice(file, signed) {
				this.clearOffice();
				this._officeReq = this.request({
					url: '/oss/weboffice/token/get',
					data: {
						filepath: signed
					},
					success: data => {
						if (this._destroyed || this.currentFile != file) return;
						data.time = new Date().getTime();
						this._officeToken = data;
						this.$nextTick(() => {
							let box = this.$refs.officeBox;
							//容器必须仍在文档中，避免挂载到已脱离文档的孤儿节点
							if (this._destroyed || this.currentFile != file || !box || !document.contains(box)) return;
							this._office = aliyun.config({
								url: data.webofficeURL,
								mount: box
							});
							this._office.setToken({
								token: data.accessToken,
								timeout: 60 * 60 * 1000
							});
						});
						this.loopOfficeToken();
					}
				});
			},

			//WebOffice token续期
			loopOfficeToken() {
				clearTimeout(this._officeTimer);
				this._officeTimer = setTimeout(() => {
					let data = this._officeToken;
					if (!data) return;
					if (new Date().getTime() - data.time >= 50 * 60 * 1000) {
						this.request({
							url: '/oss/weboffice/token/refresh',
							data: {
								accessToken: data.accessToken,
								refreshToken: data.refreshToken
							},
							success: ndata => {
								//实例已销毁（切换预览/清空）则丢弃续期结果，避免复活token与定时器
								if (this._destroyed || !this._office) return;
								ndata.time = new Date().getTime();
								this._officeToken = ndata;
								this._office.setToken({
									token: ndata.accessToken,
									timeout: 60 * 60 * 1000
								});
								this.loopOfficeToken();
							}
						});
					} else {
						this.loopOfficeToken();
					}
				}, 60000);
			},

			clearOffice() {
				clearTimeout(this._officeTimer);
				this._officeTimer = null;
				this._officeToken = null;
				this._officeReq && this._officeReq.abort && this._officeReq.abort();
				this._officeReq = null;
				//SDK为模块级单例，仅在下一次config时才销毁上一个实例，
				//故切换预览类型时必须显式destroy，否则iframe与resize监听残留并叠加显示
				if (this._office && this._office.destroy) {
					try {
						this._office.destroy();
					} catch (e) {}
				}
				this._office = null;
				this.removeOfficeDom();
			},

			//兜底清理SDK残留DOM：单例iframe可能挂在已脱离文档的容器或body下
			removeOfficeDom() {
				let nodes = document.querySelectorAll('.web-office-iframe, .web-office-default-container');
				for (let i = 0; i < nodes.length; i++) {
					nodes[i].parentNode && nodes[i].parentNode.removeChild(nodes[i]);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	//组件库全局.c-empty带sticky居中与固定宽200px（面向表格滚动区设计）；
	//且.flex-grow含width:0（行布局basis），非flex容器下使用会压零宽度。
	//本页作为区块级空状态：重置定位与宽度，主区空状态不挂flex-grow（组件自带height:100%）
	.c-empty {
		position: static;
		left: auto;
		width: auto;
		transform: none;
	}

	//伪全屏：fixed铺满视口；层级低于库body级下拉面板(z-index 2001)，保证全屏下下拉可见
	.c-page.z-full {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 1500;
		background: #fff;
	}

	//摄像头扫码浮层：暗色遮罩+取景框+扫描线
	.camera {
		gap: 16px;
		z-index: 2100;
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, .75);
		backdrop-filter: blur(4px);

		&-main {
			position: relative;
			width: 480px;
			height: 480px;
			overflow: hidden;
			border-radius: 8px;
			background: #000;

			video {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		//解码用画布移出视口
		&-canvas {
			position: fixed;
			left: 100vw;
			top: 0;
		}

		&-line {
			position: absolute;
			inset: 0;
			overflow: hidden;
			animation-name: cameraLine;
			animation-duration: 3s;
			animation-timing-function: linear;
			animation-iteration-count: infinite;

			&:after {
				content: '';
				display: block;
				width: 100%;
				margin-top: 20px;
				box-shadow: 0 0 8px 3px #05AD5D;
			}

			@keyframes cameraLine {
				0% {
					opacity: 0;
					transform: translate(0, 0);
				}
				10% {
					opacity: 1;
				}
				90% {
					opacity: 1;
				}
				100% {
					opacity: 0;
					transform: translate(0, calc(100% - 40px));
				}
			}
		}

		&-tip {
			font-size: 13px;
			color: rgba(255, 255, 255, .8);
		}

		&-close {
			width: 44px;
			height: 44px;
			border-radius: 50%;
			font-size: 18px;
			color: #fff;
			background: rgba(0, 0, 0, .5);
			cursor: pointer;
		}
	}

	.side {
		box-sizing: border-box;
		height: 100%;
		padding: 16px;

		.tabs {
			gap: 8px;
			padding: 4px;
			border-radius: 6px;
			background: #F2F3F5;

			a {
				flex-grow: 1;
				gap: 6px;
				height: 32px;
				border-radius: 4px;
				font-size: 13px;
				color: #666;
				cursor: pointer;

				&.z-crt {
					background: #D9F2E5;
					color: var(--color-main);
				}
			}
		}

		&-input {
			margin-top: 14px;

			//类型与搜索下拉无缝拼成组合控件：去除间隔、相接边框合并、仅外侧保留圆角
			.side-type.c-select {
				width: 90px;
				border-right: 0;
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
			}

			.flex-grow.c-select {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}
		}

		//扫码状态条+摄像头扫码按钮行
		&-scan-row {
			gap: 8px;
			margin-top: 14px;
		}

		//摄像头扫码按钮：状态条右侧方钮（border-box含边框，与状态条同高34px）
		&-camera {
			box-sizing: border-box;
			flex-shrink: 0;
			width: 38px;
			height: 38px;
			border: 1px solid var(--unit-border);
			border-radius: 4px;
			font-size: 15px;
			color: #666;
			background: #F7F8FA;
			cursor: pointer;

			&:hover {
				border-color: var(--color-main);
				color: var(--color-main);
			}
		}

		//扫码动态状态条：图标+文案随状态变色
		&-scan {
			box-sizing: border-box;
			gap: 8px;
			height: 38px;
			padding: 0 10px;
			border: 1px solid var(--unit-border);
			border-radius: 4px;
			background: #F7F8FA;
			font-size: 13px;
			color: #999;

			i {
				font-size: 15px;
			}

			&.z-loading {
				border-color: #BEDAFF;
				background: #E8F3FF;
				color: #2B73E7;
			}

			&.z-success {
				border-color: #B7E7D2;
				background: #D9F2E5;
				color: var(--color-main);
			}

			&.z-error {
				border-color: #FDCDC5;
				background: #FFECE8;
				color: #F53F3F;
			}
		}

		&-info {
			flex-grow: 1;
			min-height: 0;
			margin-top: 18px;
			overflow: auto;

			> div {
				padding: 4px 0;

				&:not(:last-child) {
					border-bottom: 1px solid #F7F8FA;
				}
			}

			dt {
				float: left;
				width: 80px;
				line-height: 24px;
				font-size: 13px;
				color: #999;
			}

			dd {
				margin-left: 90px;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				word-break: break-all;
			}
		}
	}

	.bar {
		gap: 10px;
		height: 46px;
		padding: 0 16px;
		border-bottom: 1px solid var(--unit-border);

		&-field {
			width: 160px;
		}

		&-files {
			gap: 6px;
			overflow: hidden;

			li {
				box-sizing: border-box;
				width: 32px;
				height: 32px;
				border: 1px solid var(--unit-border);
				border-radius: 6px;
				font-size: 20px;
				overflow: hidden;
				background: #F5F5F5;
				cursor: pointer;

				&.z-crt {
					border-color: var(--color-main);
					box-shadow: 0 0 0 2px #D9F2E5;
				}
			}
		}
	}

	.main {
		position: relative;
		overflow: hidden;
		//画布底色：浅灰蓝基调配两抹淡彩光晕，衬托毛玻璃悬浮质感
		background: radial-gradient(600px 400px at 85% 20%, rgba(5, 173, 93, .07), transparent 60%), radial-gradient(700px 500px at 12% 88%, rgba(43, 115, 231, .06), transparent 60%), #F4F6F9;

		//工序任务目录：预览区左侧亮色磨砂玻璃悬浮面板（适配白色背景）
		.tasks-float {
			position: absolute;
			top: 16px;
			left: 16px;
			z-index: 5;
			width: 150px;
			//限高半屏：避免与垂直居中的翻页箭头（64px）重叠
			max-height: calc(50% - 42px);
			border: 1px solid rgba(255, 255, 255, .8);
			border-radius: 4px;
			//毛玻璃遮罩：半透明白渐变底+强模糊
			background: linear-gradient(135deg, rgba(255, 255, 255, .72), rgba(255, 255, 255, .5));
			box-shadow: 0 8px 24px rgba(31, 35, 41, .1);
			backdrop-filter: blur(16px) saturate(1.6);
			overflow: hidden;

			.head {
				gap: 6px;
				height: 36px;
				padding: 0 10px;
				border-bottom: 1px solid rgba(31, 35, 41, .06);
				font-size: 13px;
				color: #1D2129;

				i {
					color: #4E5969;
				}

				.count {
					margin-left: auto;
					min-width: 18px;
					padding: 0 5px;
					border-radius: 9px;
					background: rgba(31, 35, 41, .08);
					color: #4E5969;
					font-size: 12px;
					line-height: 18px;
					text-align: center;
				}
			}

			ul {
				flex-grow: 1;
				min-height: 0;
				padding: 4px;
				overflow: auto;
			}

			li {
				gap: 8px;
				height: 32px;
				padding: 0 8px;
				border-radius: 2px;
				font-size: 13px;
				color: #4E5969;
				cursor: pointer;

				&:hover {
					background: rgba(255, 255, 255, .6);
					color: #1D2129;
				}

				//选中态：毛玻璃白遮罩高亮，无指示条
				&.z-crt {
					background: rgba(255, 255, 255, .88);
					box-shadow: 0 2px 8px rgba(31, 35, 41, .06);
					color: #1D2129;
				}

				i {
					color: #1D2129;
				}
			}
		}

		.viewer {
			height: 100%;
			overflow: hidden;
			//禁用浏览器默认触屏手势（双指缩放页面/滚动），交由组件手势处理
			touch-action: none;

			//放大后可拖拽平移的光标提示
			&.z-drag {
				cursor: move;
			}

			&.z-dragging {
				cursor: grabbing;

				img {
					transition: none;
				}
			}

			img {
				max-width: 90%;
				max-height: 90%;
				transition: transform .1s;
			}

			video {
				max-width: 90%;
				max-height: 90%;
			}
		}

		.office {
			width: 100%;
			height: 100%;
		}

		.other {
			height: 100%;
			gap: 10px;

			i {
				font-size: 60px;
				color: #ccc;
			}

			p {
				font-size: 14px;
				color: #666;
			}

			.tip {
				font-size: 12px;
				color: #999;
			}
		}

		//翻页箭头：大尺寸毛玻璃圆钮（白渐变底+强模糊，hover品牌绿反馈）
		.arrow {
			position: absolute;
			top: 50%;
			width: 64px;
			height: 64px;
			border-radius: 50%;
			background: linear-gradient(135deg, rgba(255, 255, 255, .92), rgba(255, 255, 255, .68));
			backdrop-filter: blur(10px) saturate(1.4);
			border: 1px solid rgba(255, 255, 255, .95);
			box-shadow: 0 6px 20px rgba(0, 0, 0, .14), inset 0 1px 0 rgba(255, 255, 255, .8);
			color: #444;
			font-size: 28px;
			cursor: pointer;
			transform: translateY(-50%);
			transition: all .25s;

			&:hover {
				color: #05AD5D;
				box-shadow: 0 10px 28px rgba(5, 173, 93, .22), inset 0 1px 0 rgba(255, 255, 255, .8);
				transform: translateY(-50%) scale(1.1);
			}

			&:active {
				transform: translateY(-50%) scale(.94);
			}

			&.prev {
				left: 20px;
			}

			&.next {
				right: 20px;
			}
		}

		.zoom {
			position: absolute;
			bottom: 16px;
			left: 50%;
			gap: 12px;
			height: 44px;
			padding: 0 12px;
			border-radius: 8px;
			background: rgba(0, 0, 0, .45);
			backdrop-filter: blur(8px);
			color: #fff;
			font-size: 13px;
			transform: translateX(-50%);

			//缩放按钮：大圆钮+醒目图标，移动端易点按
			&-btn {
				flex-shrink: 0;
				width: 32px;
				height: 32px;
				border-radius: 50%;
				font-size: 18px;
				color: #fff;
				background: rgba(255, 255, 255, .22);
				cursor: pointer;
				transition: all .2s;

				&:hover {
					background: var(--color-main);
				}

				&:active {
					transform: scale(.92);
				}
			}

			&-percent {
				min-width: 44px;
				text-align: center;
			}

			//分隔线：缩放区与旋转/重置区隔开，防误触
			&-split {
				width: 1px;
				height: 18px;
				background: rgba(255, 255, 255, .3);
			}

			a {
				cursor: pointer;

				&.text {
					gap: 4px;
					padding: 6px 8px;

					i {
						font-size: 15px;
					}
				}
			}
		}

		.steps {
			flex-direction: column;
			height: 100%;

			//顶部图标：与工具箱入口同款字形（cms_font \ue776），低透明度品牌绿点缀引导占位
			&-icon {
				width: 100px;
				height: 100px;
				font-size: 100px;
				color: rgba(60, 173, 93, .20);
			}

			&-title {
				margin-top: 20px;
				font-size: 18px;
				font-weight: 500;
				letter-spacing: 1px;
				color: #333;
			}

			ul {
				margin-top: 44px;

				li {
					position: relative;
					width: 240px;
					text-align: center;

					//步骤连接线：横向串联相邻序号圆点，与圆心对齐
					&:not(:last-child)::after {
						content: '';
						position: absolute;
						top: 16px;
						left: calc(50% + 22px);
						right: calc(-50% + 22px);
						height: 1px;
						background: #E5E6EB;
					}

					//序号圆点：白底描边圆+投影悬浮感；完成态品牌色实底
					.num {
						position: relative;
						z-index: 1;
						display: block;
						margin: 0 auto;
						width: 32px;
						height: 32px;
						border-radius: 50%;
						border: 1px solid #E5E6EB;
						background: #fff;
						box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
						color: #999;
						font-size: 14px;
						font-style: normal;
						line-height: 30px;
						text-align: center;

						&.done {
							border-color: var(--color-main);
							background: var(--color-main);
							box-shadow: 0 4px 12px rgba(5, 173, 93, .3);
							color: #fff;
						}
					}

					.title {
						margin-top: 14px;
						line-height: 22px;
						font-size: 15px;
						font-weight: 500;
						color: #333;
					}

					.describe {
						margin-top: 4px;
						line-height: 18px;
						font-size: 12px;
						color: #999;
					}
				}
			}
		}
	}
</style>
